import { render, staticRenderFns } from "./FullscreenImage.vue?vue&type=template&id=369e86dc&"
import script from "./FullscreenImage.vue?vue&type=script&lang=js&"
export * from "./FullscreenImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports